import { IFormNumberInput } from 'cng-common/features/form/components/formNumberInput/models'
import { OnboardingFormNumberInput } from 'onboarding/components/ui/theme'

import { TAdaptingDisabled } from './types'

export const OnboardingFormNumberInputAdapter = ({
  disabled,
  isDisabled,
  ...props
}: IFormNumberInput & TAdaptingDisabled) => (
  <OnboardingFormNumberInput {...props} isDisabled={isDisabled || disabled} />
)
